import(/* webpackMode: "eager" */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\node_modules\\leaflet\\dist\\leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\node_modules\\next-intl\\dist\\esm\\navigation\\shared\\BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\node_modules\\next-intl\\dist\\esm\\navigation\\shared\\LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\node_modules\\next-intl\\dist\\esm\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\components\\Footer\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\components\\Header\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\components\\Page\\index.js");
;
import(/* webpackMode: "eager" */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\context\\providers\\DataProvider.js");
;
import(/* webpackMode: "eager" */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\context\\providers\\LanguageProvider.js");
;
import(/* webpackMode: "eager" */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\context\\providers\\UIProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Arman\\Work\\netspace.am\\net-space\\public\\src\\libs\\styled-registry.js");
